import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import GoogleAd from "components/googleAd/GoogleAd";
import Card from "components/card/Card";
import { PageCollapseWidth } from "../../constants";
import { useAppDispatch, useAppSelector } from "hooks";
import encodeSlice from "reducers/encodeSlice";
import { RootState } from "store";
import {
  busySelector,
  errorSelector,
  outputSelector,
} from "selectors/encodeSelectors";
import EncodeOutput from "components/encodeOutput/EncodeOuput";
import EncodeInput from "components/encodeInput/EncodeInput";
import Md5HashInfo from "components/md5HashInfo/Md5HashInfo";

const Md5EncodePage = () => {
  const dispatch = useAppDispatch();

  const handleSubmit = (input: any) => {
    dispatch(encodeSlice.actions.md5Hash({ input }));
  };

  const busy = useAppSelector((state: RootState) => busySelector(state));

  const error = useAppSelector((state: RootState) => errorSelector(state));

  const output = useAppSelector((state: RootState) => outputSelector(state));

  return (
    <>
      <Helmet>
        <title>
          MD5 Hash Generator Online – Create MD5 Checksums | ToolWeaver
        </title>
        <meta
          name="description"
          content="Generate MD5 hashes instantly with this free online tool. Your input is processed to create the checksum and is not stored."
        />
        <link rel="canonical" href="https://toolweaver.com/md5hash" />
      </Helmet>
      <Page>
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card collapseOnWidth={PageCollapseWidth} title="MD5 Hash Generator">
          {!output && (
            <EncodeInput
              onSubmit={handleSubmit}
              busy={busy}
              error={error}
              buttonText="Hash"
              header="Enter your unhashed piece of text and click the 'Hash' button."
            />
          )}
          {output && (
            <EncodeOutput output={output} header="Your hashed text is below." />
          )}
        </Card>

        <GoogleAd showOnWidth={PageCollapseWidth} type="medium-rectangle" />
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card
          isLast={true}
          collapseOnWidth={PageCollapseWidth}
          title="How does MD5 hashing work?"
          headingLevel={2}
        >
          <Md5HashInfo />
        </Card>
      </Page>
    </>
  );
};

export default memo(Md5EncodePage);
